<div class="form-report">
  <div class="tab-pad-20">
    <div class="d-flex justify-content-between">
      <div class="heading heading-sub">
        <h3 *ngIf="title">{{ title }}</h3>
      </div>
      <div>
        <div (click)="reset()" class="btn-reset" data-toggle="tooltip" data-placement="top" title="Clear Filters" [ngClass]="!isFormTouched() ? 'disabled-button':''">
          <i class="icon-delete"></i>
        </div>
      </div>
    </div>
    <div>
      <div *ngIf="showGroup">
        <a (click)="addGroup()"
          class="btn btn-common-primary add-field-btn mr-10 float-right btn-center-primary add-group">Add Group</a>
      </div>
    </div>
    <ng-container *ngFor="let group of controls; let groupIndex = index" [formGroup]="formGroupParse(group)">
      <hr *ngIf="groupIndex > 0" />
      <div class="form-custom-di">
        <div class="my-2 mb-3">
          <div class="mt-1" *ngIf="groupIndex > 0">
            <div class="form-group mt-2">
              <h4>{{ groupSeperatorText || "" }}</h4>
            </div>
          </div>
          <div class="d-flex justify-content-between w-100 my-3">
            <div style="min-width: 260px" *ngIf="conditionType">
              <app-select [form]="formGroupParse(group)" [controlName]="keys.ConditionType" [options]="filterOptions"
                [requiredMark]="!clearValidationOnDeselect &&
                  formGroupParse(group).dirty &&
                  formGroupParse(group).invalid &&
                  formGroupParse(group).controls[keys.ConditionType].invalid
                "
                [isLoading]="isLoading"
                [isError]="isError"></app-select>
            </div>
            <div class="d-flex align-items-center" *ngIf="controls.length > 1">
              <button type="button" (click)="removeGroup(groupIndex)"
                class="btn btn-action-common btn-remove btn-action-text add-group bg-danger text-white">
                <span class="text">Remove Group</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="table-relationship-area-div">
        <div class="row">
          <div class="col-lg-12 col-md-12">
            <div class="card-table-area-inner">
              <div class="custom-table-div form-custom-div table-mapping table-filter">
                <div class="table-responsive form-custom-table">
                  <table class="table table-border-less">
                    <thead class="thead-light">
                      <tr>
                        <th *ngFor="let column of columns; index as i">
                          <ng-container *ngIf="i != 3 ? true : ConditionGroupType === 'user' ? false : true">
                            {{ column }}
                          </ng-container>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="
                          let filter of getGroupControls(formGroupParse(group));
                          let condIndex = index
                        " [formGroup]="formGroupParse(filter)">
                        <td>
                          <app-select
                            *ngIf="ConditionGroupType === 'user' ? false : true"
                            [controlName]="keys.FieldKey"
                            [form]="formGroupParse(filter)"
                            [options]="filter.value.ColumnOptions"
                            (selected)="selectedColumn($event, filter)"
                            [requiredMark]="
                              formGroupParse(group).dirty &&
                              formGroupParse(group).invalid &&
                              formGroupParse(filter).controls[keys.FieldKey]
                                .invalid
                            "
                            [isLoading]="isLoading"
                            [isError]="isError"
                          ></app-select>

                          <app-input
                            *ngIf="ConditionGroupType === 'user' ? true : false"
                            type="text"
                            [controlName]="keys.FieldKey"
                            [form]="formGroupParse(filter)"
                            [disabled]="true"
                            [placeholder]="'Current User'"
                          ></app-input>

                        </td>
                        <td *ngIf="filterColumns?.length">
                          <app-select
                            *ngIf="ConditionGroupType === 'user' ? false : true"
                            [controlName]="keys.QueryCondition"
                            [form]="formGroupParse(filter)"
                            [options]="filter.value.ConditionOptions"
                            (selected)="getQueryCondition(filter)"
                            [requiredMark]="
                              formGroupParse(group).dirty &&
                              formGroupParse(group).invalid &&
                              formGroupParse(filter).controls[
                                keys.QueryCondition
                              ].invalid
                            "
                            [isLoading]="isLoading"
                            [isError]="isError"
                          ></app-select>
                          <app-select
                            *ngIf="ConditionGroupType === 'user' ? true : false"
                            [controlName]="keys.QueryCondition"
                            [form]="formGroupParse(filter)"
                            [options]="userConditionGroupOptions"
                            (selected)="getRoleFilterCondition(filter)"
                            [requiredMark]="
                              formGroupParse(group).dirty &&
                              formGroupParse(group).invalid &&
                              formGroupParse(filter).controls[
                                keys.QueryCondition
                              ].invalid
                            "
                            [isLoading]="isLoading"
                            [isError]="isError"
                          ></app-select>
                        </td>
                        <td *ngIf="!filterColumns?.length">
                          <app-select
                            *ngIf="ConditionGroupType === 'user' ? false : true"
                            [controlName]="keys.QueryCondition"
                            [form]="formGroupParse(filter)"
                            [options]="filter.value.ConditionOptions"
                            [requiredMark]="
                              formGroupParse(group).dirty &&
                              formGroupParse(group).invalid &&
                              formGroupParse(filter).controls[
                                keys.QueryCondition
                              ].invalid
                            "
                          ></app-select>
                        </td>
                        <td *ngIf="!filterColumns?.length">
                          <app-select
                            *ngIf="ConditionGroupType === 'user' ? false : true"
                            [controlName]="keys.QueryCondition"
                            [form]="formGroupParse(filter)"
                            [options]="filter.value.ConditionOptions"
                            [requiredMark]="
                              formGroupParse(group).dirty &&
                              formGroupParse(group).invalid &&
                              formGroupParse(filter).controls[
                                keys.QueryCondition
                              ].invalid
                            "
                          ></app-select>
                        </td>
                        <td 
                          *ngIf="(ConditionGroupType === 'user' ? false : true) && filterColumns?.length">
                          <app-select
                            (selected)="getValueSelection(filter)"
                            [multiple]="filter.value.CurrentFieldType === 'ENUM2' && multipleChoiceFields.includes(filter.value[keys.QueryCondition])"
                            [value]="filter.value.Value"
                            *ngIf="
                              filter.value[keys.QueryCondition] != null &&
                              (filter.value[keys.QueryCondition].includes(
                                'value in field'
                              ) ||
                                filter.value[keys.QueryCondition] ===
                                  'before_date' ||
                                filter.value[keys.QueryCondition] ===
                                  'on_or_before_date' ||
                                filter.value[keys.QueryCondition] ===
                                  'after_date' ||
                                filter.value[keys.QueryCondition] ===
                                  'on_or_after_date') || (multipleChoiceFields.includes(filter.value[keys.QueryCondition]) && (filter.value.CurrentFieldType === 'ENUM' || filter.value.CurrentFieldType === 'ENUM2'))
                            " [controlName]="keys.Value" [form]="formGroupParse(filter)"
                            [options]="filter?.value?.ValuesFilter ? filter?.value?.ValuesFilter : null " [requiredMark]="
                              formGroupParse(group).dirty &&
                              formGroupParse(group).invalid &&
                              formGroupParse(filter).controls[keys.Value]
                                .invalid
                            "
                            [isLoading]="isLoading"
                            [isError]="isError">
                          </app-select>

                          <div *ngIf="
                                filter.value[keys.QueryCondition] != null &&
                                filter.value[keys.QueryCondition] ===
                                  'is equal to user'
                              " class="select-search-field">
                            <app-select-search-scroll *ngIf="
                                filter.value[keys.QueryCondition] != null &&
                                filter.value[keys.QueryCondition] ===
                                  'is equal to user'
                              " [controlName]="keys.Value" [form]="formGroupParse(filter)" [minSearchLength]="3"
                              [searchable]="true" [scrollable]="true" [isConditionComponent]="true" [requiredMark]="
                                formGroupParse(group).dirty &&
                                formGroupParse(group).invalid &&
                                formGroupParse(filter).controls[keys.Value]
                                  .invalid
                              " [passedTableKey]="passedTableKey" [options]="userOptions"></app-select-search-scroll>
                          </div>
                          <!-- [options]="selectOptions(col)"
                          (selected)="
                          setSelectedValue($event, formGroupAt(col))
                        " -->

                          <!-- <app-select
                            *ngIf="
                              filter.value[keys.QueryCondition] != null &&
                              filter.value[keys.QueryCondition] ===
                                'is equal to user'
                            "
                            [controlName]="keys.Value"
                            [form]="formGroupParse(filter)"
                            [options]="users"
                            [requiredMark]="
                              formGroupParse(group).dirty &&
                              formGroupParse(group).invalid &&
                              formGroupParse(filter).controls[keys.Value]
                                .invalid
                            "
                          >
                          </app-select> -->

                          <app-select *ngIf="
                              filter.value[keys.QueryCondition] != null &&
                              filter.value[keys.QueryCondition] ===
                                'true or false'
                            " [controlName]="keys.Value" [form]="formGroupParse(filter)" [options]="boolValues"
                            [requiredMark]="
                              formGroupParse(group).dirty &&
                              formGroupParse(group).invalid &&
                              formGroupParse(filter).controls[keys.Value]
                                .invalid
                            "
                            [isLoading]="isLoading"
                            [isError]="isError">
                          </app-select>

                          <app-input *ngIf="
                          filter.value[keys.QueryCondition] != null && filter.value.CurrentFieldType === 'EMAIL' && 
                          (filter.value[keys.QueryCondition] ===
                            'is equal' ||
                          filter.value[keys.QueryCondition] ===
                            'is not equal' )
                        " [controlName]="keys.Value" type="email" [form]="formGroupParse(filter)"
                        [requiredMark]="
                          formGroupParse(group).dirty &&
                          formGroupParse(group).invalid &&
                          formGroupParse(filter).controls[keys.Value]
                            .invalid
                        ">
                          </app-input>

                          <app-input *ngIf=" !(multipleChoiceFields.includes(filter.value[keys.QueryCondition]) && (filter.value.CurrentFieldType === 'ENUM' || filter.value.CurrentFieldType === 'ENUM2'))" [hidden]="
                              filter.value[keys.QueryCondition] != null &&
                              (filter.value[keys.QueryCondition] ===
                                'true or false' ||
                                filter.value[keys.QueryCondition] ===
                                  'is equal to user' ||
                                filter.value[keys.QueryCondition].includes(
                                  'value in field'
                                ) || 
                                (filter.value.CurrentFieldType === 'EMAIL' && 
                                (filter.value[keys.QueryCondition] ===
                                  'is equal' ||
                                filter.value[keys.QueryCondition] ===
                                  'is not equal') ) ||
                                filter.value[keys.QueryCondition] ===
                                  'before_date' ||
                                filter.value[keys.QueryCondition] ===
                                  'on_or_before_date' ||
                                filter.value[keys.QueryCondition] ===
                                  'after_date' ||
                                filter.value[keys.QueryCondition] ===
                                  'on_or_after_date' ||
                                filter.value[keys.QueryCondition] ===
                                  'between_date' ||
                                filter.value[keys.QueryCondition] ===
                                  'not_between_date')
                            " [type]="getInputType(filter)" [fieldSize]="getFieldSize(filter.value[keys.FieldKey])" [controlName]="keys.Value" [form]="formGroupParse(filter)" [disabled]="
                              filter.value[keys.QueryCondition] ===
                                'currentuser' ||
                              filter.value[keys.QueryCondition] === 'ccu' ||
                              filter.value[keys.QueryCondition] === 'empty' ||
                              filter.value[keys.QueryCondition] === 'has value'
                            " 
                            [placeholder]="filter.value.CurrentFieldType ==='VARCHAR(15)' && (filter.value[keys.QueryCondition] === 'is equal' || filter.value[keys.QueryCondition] === 'is not equal')?'(000) 000-0000':'Enter here'"
                            [mask]="filter.value.CurrentFieldType ==='VARCHAR(15)' && (filter.value[keys.QueryCondition] === 'is equal' || filter.value[keys.QueryCondition] === 'is not equal')?'(000) 000-0000':''"
                            [requiredMark]="
                              formGroupParse(group).dirty &&
                              formGroupParse(group).invalid &&
                              formGroupParse(filter).controls[keys.Value]
                                .invalid
                            "></app-input>

                          <app-input *ngIf="
                              filter.value.IsCustomDate ||
                              filter.value[keys.QueryCondition] ===
                                'between_date' ||
                              filter.value[keys.QueryCondition] ===
                                'not_between_date'
                            " [type]="dateString" [controlName]="otherKeys.Date" [form]="formGroupParse(filter)"
                            [requiredMark]="
                              formGroupParse(group).dirty &&
                              formGroupParse(group).invalid &&
                              formGroupParse(filter).controls[otherKeys.Date]
                                .invalid
                            "></app-input>
                          <app-input *ngIf="
                              filter.value[keys.QueryCondition] ===
                                'between_date' ||
                              filter.value[keys.QueryCondition] ===
                                'not_between_date'
                            " [type]="dateString" [controlName]="otherKeys.Date2" [form]="formGroupParse(filter)"
                            [requiredMark]="
                              formGroupParse(group).dirty &&
                              formGroupParse(group).invalid &&
                              formGroupParse(filter).controls[otherKeys.Date2]
                                .invalid
                            "></app-input>
                        </td>
                        <td *ngIf="(ConditionGroupType === 'user' ? false : true) && !filterColumns?.length"> 
                          <app-input  [controlName]="keys.Value" type="text" [form]="formGroupParse(filter)"></app-input>
                        </td>

                        <td 
                          *ngIf="ConditionGroupType === 'user' ? true : false">

                          <app-select
                            (selected)="getValueSelection(filter)"
                            [controlName]="keys.Value"
                            [form]="formGroupParse(filter)"
                            [options]="filter?.value?.ValuesFilter ? filter?.value?.ValuesFilter : null"
                            [requiredMark]="
                              formGroupParse(group).dirty &&
                              formGroupParse(group).invalid &&
                              formGroupParse(filter).controls[keys.Value]
                                .invalid
                            "
                            [isLoading]="isLoading"
                            [isError]="isError"
                          >
                          </app-select>

                        </td>

                        <td>
                          <ng-container *ngIf="ConditionGroupType === 'user' ? false : true">
                            <div
                              class="button-group-action d-flex align-items-center"
                            >
                              <button
                                type="button"
                                (click)="addfilter(groupIndex)"
                                *ngIf="
                                  condIndex ===
                                  getGroupControls(formGroupParse(group)).length -
                                    1
                                "
                                class="btn btn-action-common btn-add mr-2"
                              >
                                <i class="icon-add"></i>
                              </button>
                              <button
                                type="button"
                                *ngIf="
                                  condIndex !== 0 ||
                                  getGroupControls(formGroupParse(group)).length >
                                    1
                                "
                                (click)="removeFilter(groupIndex, condIndex)"
                                class="btn btn-action-common btn-add mr-2 bg-danger"
                              >
                                <i class="icon-close remove-icon-fe"></i>
                              </button>
                            </div>
                          </ng-container>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>